<template lang="pug">
  .solicitud
    b-form(@submit='onSubmit' @reset='onReset')
      b-card()
        template(#header='')
          h6.mb-0 Crear Solicitud de Información
        b-card-text
          div
            .form-group.row
              b-form-group#input-group-0.col-sm-3.col-form-label(label='Fecha:' label-for='input-fecha')
              .col-sm-5
                b-form-input(v-model='date.slice(0,10)' :disabled='true' type="date")
              b-form-group#input-group-numero.col-sm-1.col-form-label(label='Numero:' label-for='input-fecha')
              .col-sm-1
                b-form-input(v-model='numero' :disabled='true')
            .form-group.row
              span(style='color: red;') *
              b-form-group#input-group-1.col-sm-3.col-form-label(label='Tema:' label-for='input-tema')
              .col-sm-7
                b-form-input#input-tema(v-model='solicitudInformacion.tema' required='')
            .form-group.row
              span(style='color: red;') *
              b-form-group#input-group-2.col-sm-3.col-form-label(label='Tipo de Solicitud de Informacion:' label-for='input-tipo')
              .col-sm-7
                b-form-select(v-model='solicitudInformacion.tipo_rfi_codigo' :options='tipoRfiList' value-field="codigo" text-field="descripcion" required='')
            .form-group.row
              span(style='color: red;') *
              b-form-group#input-group-3.col-sm-3.col-form-label(label='Descripcion:' label-for='input-descripcion')
              .col-sm-7
                b-form-textarea#input-descripcion(v-model='solicitudInformacion.descripcion' required='' rows="5")
            .form-group.row
              span(style='color: red;') *
              b-form-group#input-group-4.col-sm-3.col-form-label(label='Fecha Fin de Recepcion de Respuestas:' label-for='input-fecha-fin-recepcion')
              .col-sm-3
                b-form-input#input-fecha-fin-recepcion(v-model='solicitudInformacion.recepcion_propuesta_fecha_fin' type="date" placeholder="Ingrese una fecha")
              span(style='color: red;') *
              b-form-group#input-group-6.col-sm-2.col-form-label(label='Hora Fin de Recepcion:' label-for='input-hora-recepcion' hide-header = '')
              .col-sm-2
                b-form-input#input-hora-recepcion.col-form-label(v-model='solicitudInformacion.recepcion_propuesta_hora_fin' type="time" required='')
            .form-group.row
              b-form-group#input-group-6.col-sm-3.col-form-label(label='Fecha de Reunion Informativa:' label-for='input-fecha-reunion')
              .col-sm-3
                b-form-input#input-fecha-reunion(v-model='solicitudInformacion.reunion_informativa_fecha' type="date" placeholder="Ingrese una fecha")
              b-form-group#input-group-6.col-sm-2.col-form-label(label='Hora Reunion Informativa:' label-for='input-hora-reunion' hide-header = '')
              .col-sm-2
                b-form-input#input-hora-reunion.col-form-label(v-model='solicitudInformacion.reunion_informativa_hora' type="time")
            .form-group.row
              b-form-group#input-group-7.col-sm-3.col-form-label(label='Lugar o Link de Reunion Informativa:' label-for='input-lugar-reunion')
              .col-sm-7
                b-form-input#input-lugar-reunion(v-model='solicitudInformacion.reunion_informativa_lugar')


            div(v-if="this.contactoModal == false")
              button.btn.btn-primary.m-1(@click.prevent='agregarContacto()') Agregar Contactos
              .card.table-panel(id='')
                .card-header
                  h3.card-title
                    | Contactos
                .card-body.table-responsive
                  table.table.table-bordered.table-condensed.table-striped.table-hover
                    thead
                      tr
                        th.text-center.w-25 Nombre
                        th.text-center.w-25 Cargo
                        th.text-center.w-25 Correo Electronico
                        th.text-center.w-25 Telefono
                        th.text-center.w-auto() Acciones
                    tbody()

                      tr( v-for='(row,index) in listaContactos')
                        td.text-center  {{row.nombre}}
                        td.text-center {{row.cargo}}
                        td.text-center {{row.correo_electronico}}
                        td.text-center {{row.telefono}}
                        td()
                          .btn-group
                            b-dropdown.m-md-1(text='Acciones')
                              b-dropdown-item(@click.prevent='modificarContacto(row,index)') Modificar
                              b-dropdown-item(@click.prevent='borrarContacto(row,index)') Borrar

            b-form(@submit='onSubmitContacto' @reset='onResetContacto')
              b-card(v-if="this.contactoModal == true")
                template(#header='')
                  h6.mb-0 Agregar Contacto
                b-card-text
                  div
                    .form-group.row
                      span(style='color: red;') *
                      b-form-group#input-group-1.col-sm-1.col-form-label(label='Nombre:' label-for='input-nombre')
                      .col-sm-7
                        b-form-input#input-nombre(v-model='contacto.nombre')
                    .form-group.row
                      span(style='color: red;') *
                      b-form-group#input-group-2.col-sm-1.col-form-label(label='Cargo:' label-for='input-cargo')
                      .col-sm-7
                        b-form-input#input-cargo(v-model='contacto.cargo' required='')
                    .form-group.row
                      span(style='color: red;') *
                      b-form-group#input-group-3.col-sm-1.col-form-label(label='Correo:' label-for='input-correo')
                      .col-sm-7
                        b-form-input#input-correo(v-model='contacto.correo_electronico' type='email' required='')
                    .form-group.row
                      span(style='color: red;') *
                      b-form-group#input-group-3.col-sm-1.col-form-label(label='Telefono:' required='' label-for='input-telefono')
                      .col-sm-7
                        b-form-input#input-telefono(v-model='contacto.telefono' )

                    div.float-right
                      button.btn.btn-primary.m-1(type='reset' variant='danger') Volver
                    button.btn.btn-primary.m-1(type='submit' variant='primary') Guardar Contacto
                    //b-button(type='submit' variant='primary') Submit
                    //b-button(type='reset' variant='danger') Reset

            div(v-if="this.contactoModal == false")
              button.btn.btn-primary.m-1(type='reset' variant='danger') Volver
              button.btn.btn-danger.m-1.float-right(type='submit' variant='primary') Guardar

    modal(:title="modalTitulo" :texto="modalTexto"
      :modalShow="modalShow"
      :button-action-name="modalBoton"
      @confirmed='confirmarAccionModal()'
      @close="modalShow = !modalShow"
    )



</template>


<script>

import {HTTP} from '../http';
import moment from 'moment'
import functions from "../mixins/functions";
import Modal from "../components/Modal";

export default {
  name: "SolicitudInformacionCrear",
  mixins: [functions],
  components: {
    Modal
  },
  data() {
    return {
      solicitudInformacion: {},
      contacto: {},
      listaContactos: [],
      selected: null,
      tipoRfiList: [],
      date: new Date().toISOString(),
      numero: null,
      hide: false,
      contactoModal: false,
      indexModificado: null,
      loading: false,
      modalShow: false,
      modalTitulo: "",
      modalTexto: "",
      modalBoton: "",

    }
  },
  async mounted() {
    this.activeSpinner();

    window.scrollTo(0,0);
    this.tipoRfiList = (await HTTP.get('/selectores/parametros', { params: {dominio: "RFI_TIPO_SOLICITUD_INFORMACION"}})).data.list;
    this.numero = (await HTTP.post('/solicitudInformacion/getNroRfi')).data + 1;

    this.desactiveSpinner();
    console.log(this.date.slice(0,10))
    console.log(this.solicitudInformacion.recepcion_propuesta_fecha_fin)
  },
  methods:{
    onSubmit(event) {
      if(this.solicitudInformacion.reunion_informativa_lugar === "" || this.solicitudInformacion.reunion_informativa_lugar == null)
        this.solicitudInformacion.reunion_informativa_lugar = undefined
      if((typeof(this.solicitudInformacion.reunion_informativa_lugar) !== 'undefined'
              && isNaN(new Date(this.solicitudInformacion.reunion_informativa_fecha))) ||
          typeof(this.solicitudInformacion.reunion_informativa_lugar) === 'undefined'
          && !isNaN(new Date(this.solicitudInformacion.reunion_informativa_fecha))) {
        window.scrollTo(0, 0);
        this.$root.$emit('showNotificationWarning', {mensaje: 'Debe ingresar la fecha y lugar de la Reunion informativa'});
        event.preventDefault()
      }else if(this.concatDateTime(this.solicitudInformacion.recepcion_propuesta_fecha_fin,this.solicitudInformacion.recepcion_propuesta_hora_fin) <
            this.concatDateTime(new Date().toISOString().slice(0, 10),new Date().toLocaleTimeString('en-GB'))){
          window.scrollTo(0, 0);
          this.$root.$emit('showNotificationWarning', {mensaje: 'La fecha de Recepcion de Respuestas no puede ser menor al dia de hoy'});
          event.preventDefault()
          //controla si la fecha de reunion informativa es menor al dia de hoy
      }else if(this.concatDateTime(this.solicitudInformacion.reunion_informativa_fecha,this.solicitudInformacion.reunion_informativa_hora) <
          this.concatDateTime(new Date().toISOString().slice(0, 10),new Date().toLocaleTimeString('en-GB'))){
        window.scrollTo(0, 0);
        this.$root.$emit('showNotificationWarning', {mensaje: 'La fecha de la Reunion Informativa no puede ser menor al dia de hoy'});
        event.preventDefault()
      }else if(!isNaN(new Date(this.solicitudInformacion.reunion_informativa_fecha)) && this.concatDateTime(this.solicitudInformacion.recepcion_propuesta_fecha_fin,this.solicitudInformacion.recepcion_propuesta_hora_fin) <
          this.concatDateTime(this.solicitudInformacion.reunion_informativa_fecha,this.solicitudInformacion.reunion_informativa_hora)){
        window.scrollTo(0, 0);
        this.$root.$emit('showNotificationWarning', {mensaje: 'La fecha de la Reunion Informativa no puede ser mayor a la fecha de Recepcion de Respuestas'});
        event.preventDefault()
        //controla si la fecha de recepcion de respuestas es menor al dia de hoy
      }else{
        //this.save(this.solicitudInformacion)
        this.mostrarModal()

        event.preventDefault()
      }
    },

    mostrarModal(){
      window.scrollTo(0,0);
      this.modalShow = !this.modalShow
      this.modalTexto = "Desea crear una nueva Solicitud?"
      this.modalTitulo = "Confirmar creacion de Solicitud de Informacion"
      this.modalBoton = "Crear"
    },

    confirmarAccionModal() {
      window.scrollTo(0,0);
      this.modalShow = !this.modalShow
      this.save(this.solicitudInformacion)
    },

    onReset(event) {
      event.preventDefault()
      this.volver();
      // Trick to reset/clear native browser form validation state

    },

    onSubmitContacto(event) {
      event.preventDefault();
      this.grabarContacto(this.contacto)
    },
    onResetContacto(event) {
      event.preventDefault()
      this.contacto = {};
      this.indexModificado = null ;
      this.contactoModal = false;
    },

    save: async function (instance) {
      this.activeSpinner();

      instance.contactos = []
      if (this.listaContactos.length > 0){
        this.listaContactos.forEach(contacto => {
          let contactoSave = {
            nombre: contacto.nombre,
            cargo: contacto.cargo,
            correo_electronico: contacto.correo_electronico,
            telefono: contacto.telefono
          }
          instance.contactos.push(contactoSave)
        })
        try {
          if(this._checkPerfil('rfi_convocante_admin')){
            if(typeof(sessionStorage.getItem("uoc")) !== 'undefined' || sessionStorage.getItem("uoc")!== null)
              instance.unidad_contratacion_id = sessionStorage.getItem("uoc")
              instance.origen_rfi = "CONVOCANTE"
          } else if(this._checkPerfil('rfi_convenio_admin')){
            instance.unidad_contratacion_id = null
            instance.origen_rfi = "CONVENIO"
          }

          instance.numero = this.numero;
          instance.estado_codigo = "BORRADOR";
          instance.recepcion_propuesta_fecha_fin = this.concatDateTime(instance.recepcion_propuesta_fecha_fin,instance.recepcion_propuesta_hora_fin)
          instance.reunion_informativa_fecha = this.concatDateTime(instance.reunion_informativa_fecha,instance.reunion_informativa_hora)

          const data = await (HTTP.post('/solicitudInformacion/create', instance));
          this.$router.push({path: "/solicitud_informacion/modificar", query:{id: encodeURIComponent(data.data)}});
          this.$root.$emit('showNotificationSuccess', {mensaje: 'Se ha creado la Solicitud de Informacion'});
        } catch (error) {
          console.log(error);
          this.$root.$emit('showNotificationError', {mensaje: 'Ha ocurrido un error al crear Solicitud de informacion'});
          window.scrollTo(0,0);
        }
      } else {
        window.scrollTo(0,0);
        this.$root.$emit('showNotificationError', {mensaje: 'Se Debe agregar al menos un contacto'});
      }
      this.desactiveSpinner();

    },
    clear: function () {
      this.solicitudInformacion= {};
    },
    volver: function () {
      this.$router.push({path: "/"})
    },

    agregarContacto: function () {
      this.contacto = {};
      this.contactoModal = true ;
    },

    grabarContacto: function (instance) {
      this.contactoModal = false ;

      if(this.indexModificado != null){
        this.listaContactos.splice(this.indexModificado,1)
      }
      this.indexModificado=null
      this.listaContactos.push(
          {nombre: instance.nombre,
           cargo: instance.cargo,
           correo_electronico:instance.correo_electronico ,
           telefono:instance.telefono}
      );
    },

    concatDateTime: function (fecha, hora){
      var momentObj = moment(fecha + hora, 'YYYY-MM-DDLT');
      return momentObj.format('YYYY-MM-DD HH:mm:s');
    },

    

    modificarContacto: function (instance,index){
      this.contactoModal = true ;
      this.contacto = instance;
      this.indexModificado = index ;
    },

    borrarContacto: function (instance,index){
      this.listaContactos.splice(index,1)
    }


  }
}
</script>

<style scoped>


</style>
